import script from "./SocialFundContactDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundContactDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundContactDialog.vue?vue&type=style&index=0&id=13a5d130&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a5d130"]])

export default __exports__